import { useCallback, useEffect } from 'react';
import { useScrollToTopButton } from 'hooks/useScrollToTopButton';
import { EXTRA_PIXEL_HEIGHT } from './constants';
import {
  StyledScrollToTopButton,
  StyledScrollToTopButtonOutside
} from './styled';

export const ScrollToTopButton = (): React.JSX.Element => {
  const { visible, handleClick } = useScrollToTopButton();

  const setPositionOfButton = useCallback(() => {
    const scrollToTopButtonClassName = document.getElementsByClassName(
      'scroll-to-top-button'
    ) as HTMLCollectionOf<HTMLElement>;
    const pageHeaders =
      document.getElementsByClassName(
        'ag-root ag-unselectable ag-layout-normal'
      ) || [];
    const lastPageHeaderTop =
      pageHeaders?.[pageHeaders.length - 1]?.getBoundingClientRect()?.top;
    if (
      scrollToTopButtonClassName &&
      (lastPageHeaderTop || lastPageHeaderTop === 0)
    ) {
      scrollToTopButtonClassName[
        scrollToTopButtonClassName.length - 1
      ].style.top = `${lastPageHeaderTop + EXTRA_PIXEL_HEIGHT}px`;
    }
  }, []);

  const handleResize = useCallback(() => {
    setPositionOfButton();
  }, [setPositionOfButton]);

  useEffect(() => {
    setPositionOfButton();
  });
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return (
    <>
      <StyledScrollToTopButtonOutside className="scroll-to-top-button">
        <StyledScrollToTopButton
          visible={visible ? 1 : 0}
          data-testid="scroll-to-top-button"
          onClick={handleClick}
        />
      </StyledScrollToTopButtonOutside>
    </>
  );
};
